export const URL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "/api/v1";
